import { useMeasureDirty } from '@app/core/hooks/useMeasureDirty';
import { Timestamp } from '@mi-front/core';
import { Box } from '@mui/material';
import pick from 'lodash/pick';
import React, { useRef, useState } from 'react';
import { useTimezone } from '../../../../../../core/hooks';
import { STREAM_SCREEN_CONFIG } from '../../config';
import { useStreamSegmentsList } from '../../hooks/segments/useStreamSegmentsQuery';
import { useFocus } from '../../stores/stream-screen.store';
import { FocusP } from './FocusP';
import { HoveredTsCtxProvider } from './hovered-ts-ctx';
import { SelectionOutOfRangeLabels } from './selection/SelectionOutOfRangeLabels';
import { useSetCursorAndPlay } from './useSetCursorAndMaybePlayOnClick';

export function Focus(p: {
  width?: number;
  height?: number;
  children?: React.ReactNode | ((p: { hoveredTs: Timestamp | null }) => React.ReactNode);
}) {
  const ref = useRef<HTMLDivElement>(null);
  const tz = useTimezone();
  const segments = useStreamSegmentsList();
  const focus = useFocus();
  const [hoveredTs, setHoveredTs] = useState<Timestamp | null>(null);

  const measures = useMeasureDirty(ref);
  const width = p.width || measures.width;
  const height = p.height || STREAM_SCREEN_CONFIG.focusHeightExpanded;

  return (
    <Box ref={ref} sx={{ width: '100%', position: 'relative', zIndex: 10 }}>
      <HoveredTsCtxProvider value={hoveredTs}>
        <FocusP
          tz={tz}
          range={pick(focus, ['from', 'to'])}
          segments={segments}
          onTsClick={useSetCursorAndPlay()}
          hoveredTs={hoveredTs}
          setHoveredTs={setHoveredTs}
          {...p}
          width={width}
          height={height}
        />
        <SelectionOutOfRangeLabels />
      </HoveredTsCtxProvider>
    </Box>
  );
}
